<template>
  <div class="flex min-h-screen flex-col bg-brand-chalk">
    <SfgTextureDefs/>
    <SfgHeader/>
    <main class="flex flex-1 flex-col">
      <slot/>
    </main>
    <SfgFooter/>
    <AboutModal/>
  </div>
</template>
